import { Component, OnInit, OnDestroy } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { FormControl, Validators } from '@angular/forms';
import { Category } from 'src/app/models/category';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/reducers/app-store';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent implements OnInit, OnDestroy {

  errorAlert = new BehaviorSubject<boolean>(false);
  errorAlert$ = this.errorAlert.asObservable();
  successAlert = new BehaviorSubject<boolean>(false);
  successAlert$ = this.successAlert.asObservable();
  alertMessg = '';
  categoryNameForm = new FormControl('', Validators.required);
  categories;
  subCategories: string[] = [];
  fileToUpload: File = null;
  task: AngularFireUploadTask;
  subscriptions: Subscription[];

  // mat-chips
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  subCategoriesChips: string[] = [];

  constructor(
    private categoryService: CategoryService,
    private storage: AngularFireStorage,
    private store: Store<{ appState: AppState }>) { }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  async ngOnInit() {
    this.subscriptions = [
      // Nos subscribimmos a las alertas para ocultarlas en despues de 3 segundos
      this.errorAlert.subscribe(showAlert => {
        if (showAlert) {
          setTimeout(() => {
            this.errorAlert.next(false);
          }, 3000);
        }
      }),
      this.successAlert.subscribe(showAlert => {
        if (showAlert) {
          setTimeout(() => {
            this.successAlert.next(false);
          }, 3000);
        }
      })
    ];
  }

  createCategory() {
    // Sleccionamos las categorias y sub-categorias del reducer
    this.store.select(state => state.appState.categories).subscribe(items => {
      this.categories = items;
    });
    this.store.select(state => state.appState.subCategories).subscribe(items => {
      this.subCategories = items;
    });

    console.log(this.categories);
    console.log(this.subCategories);
    // Validamos formulario
    if (this.categoryNameForm.invalid) {
      this.showAlert('Category name is required', true);
      return;
    }

    // Validamos que haya una imagen
    if (!this.fileToUpload) {
      this.showAlert('Category image is required', true);
      return;
    }

    // Guardamos si no hay coincidencia
    if (this.categories.find(item => item.name.toLowerCase() === this.categoryNameForm.value.toLowerCase())) {
      this.showAlert('Category already exists', true);
      return;
    } else {
      // Almacenamos en firebase
      this.startUpload();
    }
  }

  showAlert(msg: string, error: boolean) {
    this.alertMessg = msg;
    if (error) {
      this.errorAlert.next(true);
    } else {
      this.successAlert.next(true);
    }
    window.scroll(0, 0);
  }

  handleFileInput(files: FileList) {
    if (files.length > 0) {
      // Cambiamos el background del div por la imagen seleccionada
      const reader = new FileReader();
      reader.onload = () => {
        document.getElementById('categoryDrop').style.backgroundImage = `url(${reader.result})`;
        document.getElementById('categoryDrop').style.backgroundPosition = 'center';
        document.getElementById('categoryDrop').style.backgroundRepeat = 'no-repeat';
        document.getElementById('categoryDrop').style.height = '280px';
        document.getElementById('categoryDrop').style.backgroundSize = 'cover';
      };
      reader.readAsDataURL(files[0]);
      // Aqui mantenemos la imagen
      this.fileToUpload = files.item(0);
    }
  }


  async startUpload() {
    // The storage path
    const path = `category/${this.categoryNameForm.value.trim()}`;
    // Reference to storage bucket
    const ref = this.storage.ref(path);
    // The main task
    await this.storage.upload(path, this.fileToUpload);
    const downloadURL = await ref.getDownloadURL().toPromise();
    // Creamos el objeto category
    const category: Category = {
      name: this.categoryNameForm.value.trim(),
      imageUrl: downloadURL,
      subCategories: this.subCategoriesChips
    };
    // Guargamos en la BD de firbase
    this.categoryService.createCategory(category);
    this.showAlert('Category saved successfully', false);
  }


  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.subCategoriesChips.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  remove(category: string): void {
    const index = this.subCategoriesChips.indexOf(category);
    if (index >= 0) {
      this.subCategoriesChips.splice(index, 1);
    }
  }
}
